import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ChatComponent } from '../chat/chat.component';

export type ChatModalData = {
  orderCardId?: number;
  customerProfileId?: number;
  threadId?: number;
};

@Component({
  selector: 'aa-chat-modal',
  standalone: true,
  imports: [CommonModule, ChatComponent],
  templateUrl: './chat-modal.component.html',
  styleUrl: './chat-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatModalComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    protected readonly data: ChatModalData,
    protected readonly dialogRef: MatDialogRef<ChatModalComponent>,
  ) {}
}
